import { PuffLoader, PacmanLoader, RingLoader, RiseLoader, SyncLoader, HashLoader, BeatLoader, BounceLoader, BarLoader, DotLoader } from "react-spinners";

function Spinner()
{
    return(
        <div className="spinner-container">
            <DotLoader color="#a6dbd7" size={80}  />
        </div>
    );

}

export { Spinner };